/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CardSpendResponseCardOrderDto, CreateCardRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSpendRequestV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-spend-request-v-2-controller
   * @name RequestCreateCard1
   * @request POST:/api/v2/spend-request/card
   */
  requestCreateCard = (data: CreateCardRequestDto, params: RequestParams = {}) =>
    this.http.request<CardSpendResponseCardOrderDto, any>({
      path: `/v2/spend-request/card`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestCreateCardPath = '/v2/spend-request/card'
  static requestCreateCardMethod = 'POST'
}
